<ng-container *ngFor="let af of
    additionalFields">
    <div class="form-group additional-field-group" *ngIf="af.value || af.fieldType === 'BOOL'">
        <div class="form-label-div">
            <span class="form-label">{{af.name}}</span>
        </div>
        <ng-container [ngSwitch]="af.fieldType">
            <ng-container *ngSwitchCase="'DTO'">
                <div class="form-input-div">{{af.value|date: dateFormat}}</div>
            </ng-container>
            <ng-container *ngSwitchCase="'DT'">
                <div class="form-input-div">{{af.value | date:dateFormat}} {{af.value | date:'HH:mm'}}</div>
            </ng-container>
            <ng-container *ngSwitchCase="'TMO'">
                <div class="form-input-div">{{ isValidDate(af.value) === true ? (af.value | date:'HH:mm') : af.value.substring(0, 5)}}</div>
            </ng-container>
            <ng-container *ngSwitchCase="'BOOL'" >
                <div class="form-input-div">{{af.value?.toString() ==='true'?'True':'False'}}</div>
            </ng-container>
            <ng-container *ngSwitchDefault>
                <div class="form-input-div">{{af.value}}</div>
            </ng-container>
        </ng-container>
    </div>
</ng-container>
